import {DeviceType} from "../../../shared/services/device-context/device-context-vars";
import {Modal} from "react-bootstrap";
import EventRegistration from "../event-registration/event-registration";
import React, {useContext, useEffect, useState} from "react";
import "./event-registration-form.scss";
import {DeviceContext, DeviceContextState} from "../../../shared/services/device-context/device-context";

interface EventRegistrationFormProps {
    isOpen?: boolean;
    onClose?: () => void;
    eventCode: string;
}

function EventRegistrationForm({isOpen = false, onClose = () => {}, eventCode}: EventRegistrationFormProps) {

    const [showEventRegistrationModal, setShowEventRegistrationModal] = useState(false);

    const device: DeviceContextState  = useContext(DeviceContext);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowEventRegistrationModal(true);
        }, 1000);

        return () => clearTimeout(timer); // Cleanup on unmount
    }, []);

    useEffect(() => {
        setShowEventRegistrationModal(isOpen);
    }, [isOpen]);

    const closeEventRegistrationModal = () => {
        const timer = setTimeout(() => {
            setShowEventRegistrationModal(false);
            onClose();
        }, 2000);

        return () => clearTimeout(timer);
    }

    return (
        <div>
            <Modal show={showEventRegistrationModal} onHide={() => setShowEventRegistrationModal(false)}
                   centered fullscreen={ device.deviceType ===DeviceType.DESKTOP ? "false" : true } dialogClassName="event-registration-modal">
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="w-100 text-center">RSVP TO THE EVENT</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EventRegistration eventCode={eventCode} closeEventRegistrationModal={closeEventRegistrationModal}></EventRegistration>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default EventRegistrationForm;